import React from "react";
import styled from "styled-components";
import { getAssetsUrl } from "../../../utils/functions";
import PageTemplate from "../../templates/PageTemplate";
import { NOT_FOUND_IMAGE } from '../../../constants';

const WrapInner = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: ${(props) => props.theme.sizes.maxWidth};
    margin: 0 auto;
    padding-top: 140px;
    padding-right: 24px;
    padding-left: 24px;

    h3 {
        font-size: 2em;
    }

    p {
        font-size: 20px;
        line-height: 1.6;
        letter-spacing: normal;
    }

    .btn-orange {
        margin-top: 70px;
        appearance: none;
        background: var(--color-primary);
        color: #fff;
        font-size: 15px;
        padding: 12px 50px;
        border-radius: 25px;
        display: inline-block;
        border: 1px solid var(--color-primary);
        transition: All 0.5s;
        min-width: 120px;
        text-align: center;

        &:hover {
            color: var(--color-primary);
            background-color: #fff;
        }
    }
`;

function NoFound() {
    const assetsUrl = getAssetsUrl();
    const url = assetsUrl + NOT_FOUND_IMAGE;
    return (
        <PageTemplate>
            <WrapInner>
                <img src={url} loading="lazy" decoding="async" alt="404 Page Not Found"/>
                <p>The page you requested does not exist.</p>
                <p>
                    <a href="/" className="btn-orange">
                        <b>CONTINUE SHOPPING</b>
                    </a>
                </p>
            </WrapInner>
        </PageTemplate>
    );
}

export default NoFound;
